// extracted by mini-css-extract-plugin
export var emptyState = "_53-d";
export var statCard = "_53-c";
export var table = "_53-0";
export var tableCell = "_53-4";
export var tableCellClickable = "_53-5 _53-4";
export var tableCellDefault = "_53-6 _53-4";
export var tableCellEmpty = "_53-8";
export var tableCellWithValue = "_53-7";
export var tableContainer = "_53-e";
export var tableHeaderWeight = "_53-1";
export var tableHeaderZone = "_53-2";
export var tableRowHeader = "_53-3";
export var viewModeButton = "_53-9";
export var viewModeButtonActive = "_53-a _53-9";
export var viewModeButtonInactive = "_53-b _53-9";